var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "faq" } }, [
    _vm.faqData !== null && !_vm.isAFRIVERSE
      ? _c("div", [
          _c("div", { staticClass: "faq_container" }, [
            _c("h1", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.title)))]),
            _vm._v(" "),
            _c("div", { staticClass: "faq_details_container" }, [
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques1)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans1)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques2)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans2)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques3)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans3)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques4)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques5)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans5)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques7)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans7)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques8)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8)))]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isAFRIVERSE
      ? _c("div", [
          _c("div", { staticClass: "faq_container" }, [
            _c("h1", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.title)))]),
            _vm._v(" "),
            _c("div", { staticClass: "faq_details_container" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.abouttitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques1)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans1)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques2)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans2)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques3)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans3)))]),
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.substitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques4)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[0]))),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[1]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[2]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[3]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[4]))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[5]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans4[6]))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques5)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans5[0]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans5[1]))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans5[2]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans5[3]))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques6)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans6)))]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques7)))]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans7)))]),
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.unsubtitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques8)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[0]))),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[1]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[2]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[3]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[4]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[5]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[6]))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[7]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans8[8]))),
                ]),
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.contenttitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques9)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans9[0]))),
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans9[1]))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans9[2]))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans9[3]))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans9[4]))),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques10)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans10))),
                ]),
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.privacytitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques11)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans11[0]))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans11[1]))),
                ]),
              ]),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.replaceText(_vm.faqData.custtitle))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "faq_details" }, [
                _c("h3", [_vm._v(_vm._s(_vm.replaceText(_vm.faqData.ques12)))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans12[0]))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans12[1]))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.replaceText(_vm.faqData.ans12[2]))),
                ]),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }